<template>
  <div class="container">
    <input type="hidden" name="userId" v-model="userId">
   <div v-show="loading" >
      <p>送信中
       <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </p>
   </div>
      <div v-show="!loading" >
        <p>送信完了
          <i class = "material-icons">
            check_circle
          </i>
        </p>
        <router-link id="button_style" class="btn btn-outline-secondary" to="/Menu">TOP</router-link>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store.js'

export default {

  data: function() {
    return {
      mymailTitle: '',
      mymailBody: '',
      replyTo:'',
      userId:'',
      //username:'',
      loading: true
    }
  },
  created() {
    const self = this
    if(store.state.mailTitle==''){
      self.$router.replace('/Menu')
    }else{
    axios
      .post(
        'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/service/content/send',
        {
          mailTitle: store.state.mailTitle,
          mailBody: store.state.mailBody,
          destinations: store.state.destinations,
          replyTo: store.state.replyTo,
          userName:sessionStorage.getItem('userName')
        },
        {
          headers: {
            'Authorization':sessionStorage.getItem('Authorization')
          }
        }
      )
      .then(function(response) {
        console.log(response)
        store.commit('mutationType', {
        mailTitle: '',
        })
        console.log(store.state)
        self.loading = false
      })
      .catch(function(error) {
        console.log(error)
      })
    }
  },
}
</script>

<style scoped >
div {
  margin: 30px;
  text-align: center;
}
p {
  text-align: center;
  font-size: 35px;
}
</style>


// WEBPACK FOOTER //
// src/components/Completion.vue